import apiClient from '@/service/api.js';

export function isEmbedLocation(loc) {
    const current = loc || (typeof window !== 'undefined' ? window.location : null);
    if (!current) return false;
    const path = String(current.pathname || '/').toLowerCase().replace(/\/+$/, '') || '/';
    return path === '/embed' || path.endsWith('/embed') || path.endsWith('/embed.html');
}

export function readEmbedQuery(search) {
    const params = new URLSearchParams(search == null ? window.location.search : search);
    const value = (key) => params.get(key) || '';
    return {
        token: value('token'),
        userId: value('userId'),
        username: value('username'),
        assetType: value('assetType'),
        companyId: value('companyId'),
        isOnboardingCompleted: value('isOnboardingCompleted'),
        onBehalfEmail: value('onBehalfEmail'),
        onBehalfPhone: value('onBehalfPhone'),
        userType: value('userType'),
        userTimezone: value('userTimezone'),
        lang: value('lang') || 'en',
        theme: value('theme') || 'light',
        apiBaseUrl: value('apiBaseUrl')
    };
}

export function seedEmbedSession(query) {
    const session = query || {};
    if (session.token) {
        localStorage.setItem('access_token', session.token);
        localStorage.setItem('token', session.token);
    }
    if (session.userId) localStorage.setItem('userId', session.userId);
    if (session.username) localStorage.setItem('username', session.username);
    if (session.assetType) localStorage.setItem('assetType', session.assetType);
    if (session.companyId) localStorage.setItem('companyId', session.companyId);
    if (session.userType) localStorage.setItem('userType', session.userType);
    if (session.userTimezone) localStorage.setItem('TimeZone', session.userTimezone);
    if (session.lang) localStorage.setItem('lang', session.lang);
    if (session.onBehalfEmail) localStorage.setItem('userEmail', session.onBehalfEmail);
    if (session.onBehalfPhone) localStorage.setItem('userPhone', session.onBehalfPhone);
    if (session.isOnboardingCompleted) {
        localStorage.setItem('IsOnboardingCompleted', session.isOnboardingCompleted);
    }
    localStorage.setItem('userinfo', JSON.stringify({
        data: {
            id: session.userId || '',
            userName: session.username || '',
            companyId: session.companyId || '',
            email: session.onBehalfEmail || '',
            phoneNumber: session.onBehalfPhone || '',
            assetType: session.assetType || ''
        }
    }));
    localStorage.setItem('loginSource', 'Mobile');
    if (session.apiBaseUrl) {
        apiClient.defaults.baseURL = session.apiBaseUrl;
    }
    return session;
}

export function seedEmbedSessionFromLocation() {
    if (!isEmbedLocation()) return null;
    return seedEmbedSession(readEmbedQuery());
}
